export default __webpack_public_path__ + "static/media/2038.674000c6.png";